<template>
  <div id="outer_card" :key="key">
    <img :class="[this.$lang === 'ar' ? 'left-margin outer-img-ar' : 'right-margin', 'outer_image']" :src="img">
    <inner-card :data="item" :bundleType="bundleType" :cardType="type"/>
    <div :class="[this.$lang === 'ar' ? 'black-blur-right' : 'black-blur-left' , 'black-blur']"></div>
    <router-link v-if="$route.path !== '/offers' && type !== 'app' && type !== 'basic'" :to="'/bundle-details/' + this.bundleType + '/' + this.item.id">
      <a>
        <div :class="[this.$lang === 'ar' ? 'yellow-button-right' : 'yellow-button-left', 'yellow-button flex-center']">
          <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
          <img class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
          <span :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']"><a>{{$t('readMore')}}</a></span>
        </div>
      </a>
    </router-link>
    <router-link :to="'/app-details/' + this.item.id">
    <a v-if="$route.path === '/offers' || type === 'app' && type !== 'basic'"  target="_blank">
      <div :class="[this.$lang === 'ar' ? 'yellow-button-right' : 'yellow-button-left', 'yellow-button flex-center']">
        <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
        <img class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
        <span :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']"><a>{{$t('readMore')}}</a></span>
      </div>
    </a>
    </router-link>
    <router-link :to="'/offer-details/' + $store.state.offerType + '/' + this.item.id" >
      <a v-if="$route.path === '/offers' && type !== 'app' && type !== 'basic'">
        <div :class="[this.$lang === 'ar' ? 'yellow-button-right' : 'yellow-button-left', 'yellow-button flex-center']">
          <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
          <img class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
          <span :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']"><a>{{$t('readMore')}}</a></span>
        </div>
      </a>
    </router-link>
    <router-link :to="'/service-details/' + this.item.id">
    <a v-if="type === 'basic'">
      <div :class="[this.$lang === 'ar' ? 'yellow-button-right' : 'yellow-button-left', 'yellow-button flex-center']">
        <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
        <img class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
        <span :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']"><a>{{$t('readMore')}}</a></span>
      </div>
    </a>
    </router-link>
    <div :class="[this.$lang === 'ar' ? 'blur-outer-button-right' : 'blur-outer-button-left' ,'blur-outer-button']">
    </div>
  </div>
</template>

<script>
import InnerCard from './InnerCard'
// import bigOuterCard from '../../assets/icons/outer-card.svg'
// import lowBlur from '../../assets/images/low blur.svg'
// import smallOuterCard from '../../assets/images/small-outer-card.svg'
import midBlur from '../../assets/images/mid-blur.svg'
// import gc from '../../utils/gc'
// import $ from 'jquery'
export default {
  name: 'OuterCard',
  props: {
    cardType: {
      type: String
    },
    data: {
      type: Object
    },
    sliderHolder: String
  },
  components: { InnerCard },
  data () {
    return {
      type: 'basic',
      item: {},
      img: midBlur,
      message: '',
      bundleType: 'bundle',
      key: 0
    }
  },
  created () {
    this.type = this.cardType
    this.item = this.data
    this.bundleType = this.$route.path.includes('segment-details') ? 'segment' : 'bundle'
  },
  mounted () {
    // setTimeout(() => {
    //   this.$lang === 'ar' ? $('.read-more').css('animation-name', 'leftToRight') : $('.read-more').css('animation-name', 'rightToLeft')
    // })
  },
  methods: {
  }
}
</script>

<style scoped>
.white-blur-left{
  left: -4px !important;
}
.white-blur-right{
  right: -4px !important;
}
.yellow-button-left{
  right: 89.5px !important;  /*128.5*/ /* -- 95.5 -- */
}
.blur-outer-button-left{
  right: 88.5px !important; /*128.5*/ /*- 90 -*/
}
.black-blur-left{
  right: 90.5px !important; /* 100.5 */
}
.yellow-button-right{
  right: 200.5px !important;
}
.blur-outer-button-right{
  right: 198.5px !important;
}
.black-blur-right{
  right: 235.5px !important;
}
.outer-img-ar{
  transform: rotateY(180deg) !important;
}
@media (max-width: 1000px) {
    .yellow-button{
      width: 85px;
      height: 85px;
      bottom: 74px !important;
    }
    .blur-outer-button{
      width: 88px;
      height: 88px;
      bottom: 72.5px !important;
    }
    .white-blur{
      top: -4px !important;
    }
  .yellow-button-left{
    right: 87.5px !important;
  }
  .blur-outer-button-left{
    right: 86.5px !important;
  }
  .black-blur-left{
    right: 91.5px !important;
  }
  .yellow-button-right{
    right: 197px !important;
  }
  .blur-outer-button-right{
    right: 195.5px !important;
  }
  .black-blur-right{
    right: 232.5px !important;
  }
}
@media (max-width: 820px) {
  .yellow-button{
    width: 80px;
    height: 80px;
    bottom: 76px !important;
  }
  .blur-outer-button{
    width: 83px;
    height: 83px;
    bottom: 74.5px !important;
  }
  .white-blur{
    top: -4px !important;
  }
  .yellow-button-left{
    right: 85px !important;
  }
  .blur-outer-button-left{
    right: 83.5px !important;
  }
  .black-blur-left{
    right: 87.5px !important;
  }
  .yellow-button-right{
    right: 190.5px !important;
  }
  .blur-outer-button-right{
    right: 189px !important;
  }
  .black-blur-right{
    right: 222.5px !important;
  }
}
@media (max-width: 500px) {
  .yellow-button{
    width: 72px;
    height: 72px;
    bottom: 73.5px !important;
  }
  .blur-outer-button{
    width: 75px;
    height: 75px;
    bottom: 72.5px !important;
  }
  .white-blur{
    top: -4px !important;
  }
  .yellow-button-left{
    right: 76.8px !important;
  }
  .blur-outer-button-left{
    right: 75.5px !important;
  }
  .black-blur-left{
    right: 78.5px !important;
  }
  .yellow-button-right{
    right: 174.5px !important;
  }
  .blur-outer-button-right{
    right: 172.5px !important;
  }
  .black-blur-right{
    right: 195.5px !important;
  }
}
</style>
